module.exports = __webpack_public_path__ + "img/ic-tf-white.5b85b382.svg";